import { error } from "console";
import { AuditQuestion } from "../models/AuditQuestion";
import { Audit } from "../models/Audit";
import { AuditDetail } from "../models/AuditDetail";
import { Section } from "../models/Section";
import axios, { AxiosRequestConfig } from "axios";
import { saveAs } from "file-saver";
import { PolicyType } from "../models/PolicyType";
import { QuestionaryAnswer } from "../models/QuestionaryAnswer";
const API_BASE_URL = process.env.REACT_APP_AUDIT_API_URL;

const insertAnswer = async (answer: QuestionaryAnswer) => {
  const response = await fetch(`${API_BASE_URL}/QuestionaryAnswer/Insert`, {
    method: "POST",
    headers: { "Content-Type": "application/json; charset= utf-8" },
    body: JSON.stringify(answer),
  });

  return response;
};

const updateAnswer = async (answer: QuestionaryAnswer) => {
  const response = await fetch(`${API_BASE_URL}/QuestionaryAnswer/Update`, {
    method: "POST",
    headers: { "Content-Type": "application/json; charset= utf-8" },
    body: JSON.stringify(answer),
  });

  return response;
};

const deleteAnswer = async (answer: QuestionaryAnswer) => {
  const response = await fetch(`${API_BASE_URL}/QuestionaryAnswer/Delete`, {
    method: "POST",
    headers: { "Content-Type": "application/json; charset= utf-8" },
    body: JSON.stringify(answer),
  });

  return response;
};

const QuestionaryAnswerService = {
  insertAnswer,
  updateAnswer,
  deleteAnswer,
};

export default QuestionaryAnswerService;
